// test27
(27 && 0);
